import { c as _c } from "react/compiler-runtime";
import '../../../../lib/entry.browser.js';
import { createQueryFn, wagerQueryKeys } from '../../../../lib/entry.js';
import { useSuspenseQuery } from '../../../../tanstack/entry.js';
import { getWagerList } from '../../../actions/wager/entry.js';
const fetcher = createQueryFn(getWagerList);
/**
 * Function to get wager list details.
 *
 * @param product Product to fetch wager list for
 * @param queryDetails Wager detail filters
 * @param queryOptions Fetch query options
 * @returns Wager list details
 */
export function useWagerList(product, queryDetails, queryOptions) {
  const $ = _c(9);
  let t0;
  if ($[0] !== product || $[1] !== queryDetails) {
    t0 = wagerQueryKeys.wagerList(product, queryDetails);
    $[0] = product;
    $[1] = queryDetails;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = queryOptions?.defaultValue;
  let t2;
  if ($[3] !== t1) {
    t2 = fetcher({
      defaultValue: t1
    });
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== queryOptions || $[6] !== t0 || $[7] !== t2) {
    t3 = {
      ...queryOptions,
      queryKey: t0,
      queryFn: t2
    };
    $[5] = queryOptions;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useSuspenseQuery(t3);
}